export default __webpack_public_path__ + "static/media/a012-market-7.706507a9.svg";